var map = {
	"./add_icon.png": "9ade",
	"./address_icon.png": "deb5",
	"./copy_paste_icon.png": "e285",
	"./danger_icon.png": "3573",
	"./download_icon.png": "d203",
	"./electricity_icon.png": "bb06",
	"./email_icon.png": "e1c0",
	"./expired_icon.png": "1f42",
	"./gas_icon.png": "96f4",
	"./home_icon.png": "4dca",
	"./last_reading_icon.png": "ab7e",
	"./phone_icon.png": "2f77",
	"./quick_links_icon.png": "58e8",
	"./refresh_icon.png": "a3d3",
	"./remove_icon.png": "2584",
	"./reverse_icon.png": "1229",
	"./telecoms_icon.png": "a43e",
	"./view_alerts_icon.png": "5867",
	"./view_calendar_icon.png": "aa4d",
	"./view_icon.png": "92b4",
	"./view_messages_icon.png": "c3ea",
	"./view_recent_search_icon.png": "de77",
	"./view_tags_icon.png": "dcc2",
	"./warning_icon.png": "31f7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9177";